///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//

const { default: axios } = require("axios");

///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.brand_promos = abcsetup.brand_promos || {};
abcsetup.brand_promos.edit = abcsetup.brand_promos.edit || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.brand_promos.edit = {
    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        abcsetup.brand_promos.common.bindFormElems();
        abcsetup.brand_promos.edit.bindFormElems()
    },
    bindFormElems: function () {
        $(".btn-delete").on("click", function (e) {
            e.preventDefault();
            $this = $(this);
            abcsetup.blockUI(true);
            axios.post('/brand_promo_campaigns/' + $this.data('campaign-id'),{
                _method: 'DELETE'
            }).then(function (response) {
                if (response.status == 200) {
                    $this.parent().parent().remove();
                }
                abcsetup.unblockUI();
            });
        });

        $(".btn-cancel").on("click", function (e) {
            e.preventDefault();
            $this = $(this);
            abcsetup.blockUI(true);
            axios.post('/brand_promo_campaigns/cancel/' + $this.data('campaign-id')).then(function (response) {
                if (response.status == 200) {
                    console.log($this.parent().parent().find('td.status').length);
                    $this.parent().parent().find('td.status').html('Cancelled');
                }
                abcsetup.unblockUI();
            });
        });

        $(".btn-reactivate").on("click", function (e) {
            e.preventDefault();
            $this = $(this);
            abcsetup.blockUI(true);
            axios.post('/brand_promo_campaigns/reactivate/' + $this.data('campaign-id')).then(function (response) {
                if (response.status == 200) {
                    console.log($this.parent().parent().find('td.status').length);
                    $this.parent().parent().find('td.status').html('In Progress');
                }
                abcsetup.unblockUI();
            });
        });
    }
}
